module.exports = __webpack_public_path__ + "img/lang-open-m.2cc475e.png";